<!--
  @author:chen.hao
  @time:2018/10/13
  @disc:广告位管理
 -->

<template>
  <div class="ad-space-manager" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar">
      <el-form-item label="终端类型" prop="deviceType">
        <el-select v-model="form.deviceType" prop="deviceType">
          <el-option
            v-for="item in deviceTypeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告位名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入广告位名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleAdd" v-permission="'0040101'">新增</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="name"
        label="广告位名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="code"
        label="广告位标识符"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="deviceType"
        label="终端类型"
        :formatter="formatDeviceType"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="statement"
        label="位置描述"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatStatus">
      </el-table-column>
      <el-table-column
        label="操作"
        width="300px">
        <template slot-scope="scope">
          <el-button @click="infoView(scope.row)" v-permission="'0040104'">查看</el-button>
          <el-button @click="handleEdit(scope.row)" v-permission="'0040102'">编辑</el-button>
          <el-button @click="handleLock(scope.row)" v-if="scope.row.status===1" v-permission="'0040105'">禁用</el-button>
          <template v-if="scope.row.status===0">
            <el-button @click="handleLock(scope.row)" v-permission="'0040105'">启用</el-button>
            <el-button type="danger" @click="handleDelete(scope.row)" v-permission="'0040103'">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <ad-or-edit-dialog :show.sync="dialogVisible" :info="dialogInfo"></ad-or-edit-dialog>
    <info-view-dialog :show.sync="infoViewDialogVisible" :info="infoViewDialogInfo"></info-view-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AdOrEditDialog from './addOrEditDialog'
import InfoViewDialog from './infoViewDialog'
export default {
  name: 'adSpaceManager',
  components: { InfoViewDialog, AdOrEditDialog },
  data () {
    return {
      deviceTypeArr: [
        { value: '', label: '全部' },
        { value: 1, label: '商城PC端' },
        { value: 2, label: '商城APP端' },
        { value: 3, label: '司机预约微信端' },
        { value: 4, label: '物流司机端' },
        { value: 5, label: '散客司机端' }
      ],
      statusArr: [
        { value: 0, label: '已禁用' },
        { value: 1, label: '启用中' }
      ],
      form: {
        deviceType: '',
        name: ''
      },
      dialogVisible: false,
      dialogInfo: {},
      infoViewDialogVisible: false,
      infoViewDialogInfo: {}
    }
  },
  computed: {
    ...mapGetters({ list: 'getAdSpaceList', listState: 'getAdSpaceListState' })
  },
  methods: {
    ...mapActions(['getAdSpaceList', 'getAdSpaceInfo', 'deletedAdSpace', 'editAdSpace']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getAdSpaceList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getAdSpaceList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getAdSpaceList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 格式化状态
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    },
    // 格式化终端类型
    formatDeviceType (row) {
      const deviceType = this.$lodash.find(this.deviceTypeArr, { value: row.deviceType }) || {}
      return deviceType.label
    },
    // 查看
    infoView (row) {
      this.infoViewDialogInfo = { ...row, deviceType: this.formatDeviceType(row), status: this.formatStatus(row) }
      this.infoViewDialogVisible = true
    },
    // 删除
    handleDelete (row) {
      this.$confirm('是否删除该广告位？', '删除提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletedAdSpace({ id: row.id }).then(res => {
          this.getAdSpaceList({ pageNo: 1 })
        })
      }).catch(() => {})
    },
    // 新增
    handleAdd () {
      this.dialogVisible = true
      this.dialogInfo = {}
    },
    // 启用禁用
    handleLock (row) {
      const params = {
        id: row.id,
        status: row.status === 1 ? 0 : 1
      }
      this.editAdSpace(params).then(() => {
        this.handleSearch()
      })
    },
    // 编辑
    handleEdit (row) {
      this.getAdSpaceInfo({ id: row.id }).then(data => {
        this.dialogInfo = data
        this.dialogVisible = true
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
